import { getTopicFeedsComments } from "@/pages/intelligence/services/opinion";
import { useEffect, useState } from "react";

export default (props: any) => {
  const {radarLabelArr, param, filterAll, language, getSelectedTopic} = props
  // console.log("TABLEPROPS", radarLabelArr, param, filterAll)
  const [activeId, setActiveId] = useState('All Topic');

  const [tabs, setTabs] = useState([]);
  const [topicSpanList, setTopicSpanList] = useState([]);

  const [loading, setLoading] = useState(true);

  const getTableList = async (params: any, topic = [], sortItem = 'important_score') => {
    setLoading(true)

    let actChildren: any = []; // 官号
    if (filterAll?.monitor_by_account) {
      for (let v of Object.values(filterAll?.monitor_by_account?.monitory)) {
        actChildren = [...actChildren, ...v?.map((i: { account: any; }) => i?.account)];
      };
    }

    let addParams = {
      sort_item: sortItem,
      sort_model: 'desc',
      translated_to: 'origin',
      social_media_by_keyword: filterAll?.monitor_by_keyword?.monitoring || [],
      social_media_by_account: actChildren,
      review_type: "all",
      page: 1,
      page_size: 3,
      statistics_field: 'topic',
      topic: topic
    }

    try {
      let result: any = await getTopicFeedsComments({ ...params, ...addParams })

      if (result?.list) {
        let tmp = result.list.map((item: any) => {
          return {
            sentiment_rating: item.sentiment_rating,
            content: [
              item.content,
              item.content_to_en || item.content,
              item.content_to_zh || item.content
            ]
          }
        })

        // console.log("LIST", tmp)
        setTopicSpanList(tmp);
      }

      setLoading(false)
    } catch(e) {
      console.log(e)
    }
  }

  const getTabList = () => {
    let tmp = radarLabelArr?.map((item: any) => {
      return {id: item, label: item}
    })
    tmp.unshift({id: 'All Topic', label: 'All Topic'})
    setTabs(tmp)
  }

  useEffect(() => {
    if (param) {
      getTabList();
      getTableList(param)
    }
  }, [])

  useEffect(() => {
    if(activeId != 'All Topic') {
      getTableList(param, [activeId])
    } else {
      getTableList(param)
    }
    getSelectedTopic(activeId)
  }, [activeId])

  return {
    tabs,
    topicSpanList,
    activeId,
    setActiveId,
    loading,
    language
  }
}